import React, { Component } from 'react'
import CreateInquiryForm from 'containers/project-creation/create-view/create-form'
import { Formik } from 'formik'
import * as Yup from 'yup'

const feasibilityText =
  'Provide details about your scheduler project.'


class CreateInquiry extends Component{

  state = {
    initialValues: this.props.initialValues || {
      name: '',
      topicName:'',
      sampleSize: Yup.number,
      salesForceJobNumber: Yup.number,
      surveyId: Yup.string,
      salesForceClientId: Yup.string,
      interviewTimeBuffer: 24
    }
  }

  validationSchema = Yup.object().shape({
    name: Yup.string()
             .matches(/.*\S.*/, 'Project Name cannot be a whitespace')
             .required('Project Name is required')
             .max(100, 'Project Name must be less than 100 characters'),  
    topicName: Yup.string()
      .matches(/.*\S.*/, 'Topic Name cannot be a whitespace')
      .required('Topic Name is required.')
      .max(100, 'Topic Name must be less than 100 characters'),     
    interviewLength: Yup.mixed()
                        .oneOf([15, 30, 45, 60, 75, 90, 120, 150], 'Must be a valid interview length')
                        .required('Interview Duration is required'),
    sampleSize:  Yup.number()
                      .transform((value) => isNaN(value) ? undefined : value)
                      .integer('Sample Size must be a whole number')
                      .min(1, 'Sample Size must be greater than 0')
                      .required('Sample Size is required'),
    salesForceJobNumber: Yup.string()
                .matches(/.*\S.*/, 'SalesForce Job Number cannot be a whitespace')
                .required('Salesforce Job Number is required'),
    salesForceClientId: Yup.string()
                .matches(/.*\S.*/, 'Client cannot be a whitespace')
                .required('Client is required'),
    surveyId:Yup.string()
            .required()
            .matches(/^[0-9]+$/, "Survey ID must be at most a 10-digit number")
            .min(6, 'Survey ID must be at least a 6-digit number.')
            .max(10, 'Survey ID must be at most a 10-digit number'),   
  })

  render () {
    return (
      <div className="new-project-form">
        <div className="project-form">
          <div>
            <h3>New Project</h3>
            <div>
              {feasibilityText}
            </div>
            <hr/>
          </div>
          <Formik
            initialValues={this.state.initialValues}
            onSubmit={this.props.submitProjectCreation}
            validationSchema={this.validationSchema}
            render={props =>
              <CreateInquiryForm
                submitting={this.props.initialValues.submitting}
                showSnackbarMessageError={this.props.showSnackbarMessageError}
                hideSnackbarMessage={this.props.hideSnackbarMessage}
                {...props}
              />
            }
          />
        </div>
      </div>
    )
  }
}


export default CreateInquiry
